export const EsppContributionType = {
  PERCENT: 'percent_only',
  DOLLAR: 'dollar_only',
  BOTH: 'both_one_required',
};
